import * as React from "react";

import {ControlTypeEnum} from "PageBuilder/pagebuilder/Controls/NormalPDFControlFactory";
import {PRControlTypes} from "../../../../../PageBuilderPr/PRControlFactory";
import {FieldItemBase, FieldItemBaseProps, FieldItemBaseState} from "InternalShared/PageBuilder/Fields/FieldItemBase";



export class QRCodeFieldItem extends FieldItemBase<TextFieldItemProps, TextFieldItemState> {
    static defaultProps: Partial<TextFieldItemProps> = {};
    IsPR:boolean=true;
    constructor(props: TextFieldItemProps) {
        super(props);
        this.state = {

        };
    }

    protected GetImage() {
        return 'qrcode.png'
    }

    protected GetText() {
        return 'QRCode'
    }

    protected GetType() {
        return PRControlTypes.QRCode;
    }

}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface TextFieldItemProps extends FieldItemBaseProps{

}

interface TextFieldItemState extends FieldItemBaseState{

}

//#endregion "My Region"